import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DispatcherService } from '../../dispatcher/dispatcher.service';
import { DispatcherHomeService } from '../dispatcherhome/dispatcherhome.service';
import * as myGlobals from '../../globals';
import { LanguageService } from '../../language.service';
import { ConfigService } from '../../config.service';

declare var jQuery: any;
declare var $: any;
declare var moment: any;
declare var swal: any;
declare var google: any;
declare var flatpickr: any;
declare var moment: any;
declare var toastr: any;

@Component({
  selector: 'tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['../dispatcherhome/dispatcherhome.component.css', './tasks.component.css']
})
export class TasksComponent {
  online$: Observable<boolean>;
  tasks: any;
  disphome: any;
  jobdetails: any;
  invoice: any;
  cancelbooking: any;

  passDetailsContent: any;
  search: any;
  search_value: any;
  ent_driver_bid: any;
  driver_bid: any;
  driver_id: any;
  current_time: any;
  fname_b: any;
  fmail_b: any;
  route_map_lt: any;
  route_map_lng: any;
  style: any;
  mapr: any;
  cancel_status_link: any;
  ent_page_index: number = 0;
  today_task: boolean = false;
  all_task: boolean = false;
  custom_select: boolean = false;
  export_start_date: any;
  export_end_date: any;
  export_date_time: any;
  stockData: any;
  request_all: any;
  data1 = [];
  bulk_array = [];
  fphone_b: any;
  ent_request_type_num = 0;
  response_int: number = 0;
  myname;
  myphn;
  mymail;
  cancellation_bid: any;
  cancel_reasons = [];
  type = 3;
  limit = 10;
  skip = 0;
  status = '';
  fromDate = '';
  toDate = '';
  bookingSearch = '';
  bookings: any;
  totcount: any;
  range = 10;
  pageno = 1;
  outoff = 10;
  previousEnable = true;
  nextEnable = false;
  passDetailsContent1: any;

  page_index: any;
  assigned_count: any;
  completed_count: any;
  assigned_full_count: any;

  assigned = [];
  unassigned = [];
  past = [];
  errMsg: any;
  errmessage: any;
  notMinFee: any;
  invoice_link = myGlobals.invoice_admin;
  cityRange = ['10', '50', '100', '500'];

  constructor(private _router: Router, private _cookie: ConfigService, private _dispatcherService: DispatcherService, private _dispatcherHomeService: DispatcherHomeService, private languageService: LanguageService) {
    // Check for Online or Offline
    this.online$ = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').mapTo(true),
      Observable.fromEvent(window, 'offline').mapTo(false)
    )
  }

  loc_reload() {
    this.bookings = [];
    this.fromDate = '';
    this.toDate = '';
    this.search = '';
    this.status = '';
    this.limit = 10;
    this.skip = 0;
    this.range = 10;
	$('#searchKey').val('');
    this.getAllBooking();
  }
  // all bookings
  getAllBooking() {
    $("#loader_bookings_parent").show();
    this._dispatcherHomeService.getAllBooking({
      type: this.type,
      limit: this.limit,
      skip: this.skip,
      status: this.status,
      fromDate: this.fromDate,
      toDate: this.toDate,
      search: this.search
    }).subscribe((res) => {
      this.bookings = [];
      if (this.skip <= 0) {
        $('#prev').click(function (e) {
          e.preventDefault();
        });
      }
      $("#loader_bookings_parent").hide();
      if (res.data.length == 0) {
        $(".more_tooltip_error").show();
        setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
      }
      else {
        this.bookings = res.data.bookings;
        this.totcount = res.data.count;
        if (this.totcount < this.outoff) {
          this.outoff = this.totcount;
          this.nextEnable = true;
        } else {
          this.outoff = this.skip + this.range;
          this.nextEnable = false;
        }
      }
    },
      (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $("#loader_bookings_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
        }
      })
  }
  // check for enable or disable the buttons based on count
  checkForEnable(count) {
    if (count == 0) {
      this.previousEnable = true;
    } else {
      this.previousEnable = false;
    }

    const totalpages = Math.ceil(this.totcount / this.limit);
    if (this.pageno >= totalpages) {
      this.nextEnable = true;
    } else {
      this.nextEnable = false;
    }
  }
  nextbooks() {
    this.pageno++;
    this.limit = this.range;
    let inst = this.pageno - 1;
    this.checkForEnable(inst);
    this.skip = inst * this.limit;
    this.outoff = this.skip + this.range;
    this.getAllBooking();
  }
  prevbooks() {
    this.pageno--;
    this.limit = this.range;
    let inst = this.pageno - 1;
    this.checkForEnable(inst);
    this.skip = inst * this.limit;
    this.outoff = this.skip + this.range;
    this.getAllBooking();
  }

  setSearchTerm(event) {
    this.search = event.target.value;
  }
  rangebooks(event) {
    this.range = parseInt(event.target.value);
    this.bookings = [];
    this.pageno = 1;
    this.limit = this.range;
    this.skip = 0;
    this.status = '';
    this.limit = this.range;
    let inst = this.pageno - 1;
    this.checkForEnable(inst);
    this.skip = inst * this.limit;
    this.outoff = this.skip + this.range;
    this.getAllBooking();
  }

  dataSearch() {
    this.search = $("#searchKey").val();
    if (this.search == "") {
      alert("Please enter valid keyword!");
    }
    else {
      $("#loader_bookings_parent").show();
      this.getAllBooking();
    }
  }

  colorSearch(val) {
    this.search = '';
    $('#searchKey').val('');
    $('#filters_but_body').hide();
    this.status = val;
    $("#loader_bookings_parent").show();
    this.getAllBooking();
  }
  // get bookings
  getCustomerBookings(bookingId) {
    $("#loader_bookings_parent").show();
    this._dispatcherHomeService.getdata({
      bookingId: bookingId,
      callFrom: 2
    }).subscribe((res) => {
      this.passDetailsContent1 = res.data;
      $("#loader_bookings_parent").hide();
      this.notMinFee = this.passDetailsContent1.receipt.baseFee + this.passDetailsContent1.receipt.distanceFee + this.passDetailsContent1.receipt.timeFee + this.passDetailsContent1.receipt.waitingFee;
      if (res.data.dateAndTime.accepted != 0) {
        res.data.dateAndTime.accepted = moment(res.data.dateAndTime.accepted).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.onTheWay != 0) {
        res.data.dateAndTime.onTheWay = moment(res.data.dateAndTime.onTheWay).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.arrived != 0) {
        res.data.dateAndTime.arrived = moment(res.data.dateAndTime.arrived).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.created != 0) {
        res.data.dateAndTime.created = moment(res.data.dateAndTime.created).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.cancelled != 0) {
        res.data.dateAndTime.cancelled = moment(res.data.dateAndTime.cancelled).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.journeyComplete != 0) {
        res.data.dateAndTime.journeyComplete = moment(res.data.dateAndTime.journeyComplete).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.journeyStart != 0) {
        res.data.dateAndTime.journeyStart = moment(res.data.dateAndTime.journeyStart).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.unloaded != 0) {
        res.data.dateAndTime.unloaded = moment(res.data.dateAndTime.unloaded).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.expired != 0) {
        res.data.dateAndTime.expired = moment(res.data.dateAndTime.expired).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.loaded != 0) {
        res.data.dateAndTime.loaded = moment(res.data.dateAndTime.loaded).format("MMMM Do YYYY, h:mm:ss a");
      }
      if (res.data.dateAndTime.reachedDrop != 0) {
        res.data.dateAndTime.reachedDrop = moment(res.data.dateAndTime.reachedDrop).format("MMMM Do YYYY, h:mm:ss a");
      }
    });
  }

  savedriver(bid) {
    this.driver_bid = bid;
    this.cancel_status_link = 1;
  }

  // THIS FUNCTION IS INTEDED TO LOAD THE MAP AFTER DETAILS BUTTON CLICK AFTER 0.5 SECOND
  // AND SHOWS ROUTE FROM POINT GOT FROM API
  displayRoute() {
    this.style = [{
      featureType: "all",
      elementType: "labels.text.fill",
      stylers: [{
        saturation: 36
      }, {
        color: "#000000"
      }, {
        lightness: 40
      }]
    }, {
      featureType: "all",
      elementType: "labels.text.stroke",
      stylers: [{
        visibility: "on"
      }, {
        color: "#000000"
      }, {
        lightness: 16
      }]
    }, {
      featureType: "all",
      elementType: "labels.icon",
      stylers: [{
        visibility: "off"
      }]
    }, {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 20
      }]
    }, {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 17
      }, {
        weight: 1.2
      }]
    }, {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 20
      }]
    }, {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 21
      }]
    }, {
      featureType: "road.highway",
      elementType: "all",
      stylers: [{
        hue: "#ff0000"
      }, {
        visibility: "simplified"
      }, {
        saturation: "-100"
      }, {
        lightness: "-67"
      }]
    }, {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [{
        lightness: "25"
      }]
    }, {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{
        lightness: "-43"
      }, {
        saturation: "-14"
      }, {
        gamma: "1.01"
      }, {
        hue: "#ff0000"
      }, {
        visibility: "simplified"
      }]
    }, {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [{
        lightness: "-70"
      }, {
        hue: "#a4ff00"
      }, {
        saturation: "-100"
      }]
    }, {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [{
        visibility: "on"
      }, {
        hue: "#ff0f00"
      }, {
        saturation: "4"
      }, {
        lightness: "-64"
      }]
    }, {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [{
        lightness: "-69"
      }, {
        visibility: "simplified"
      }, {
        gamma: "0.94"
      }, {
        hue: "#ff0000"
      }, {
        saturation: "-100"
      }]
    }, {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{
        color: "#000000"
      }, {
        lightness: 19
      }]
    }, {
      featureType: "water",
      elementType: "geometry",
      stylers: [{
        color: "#0f252e"
      }, {
        lightness: 17
      }]
    }]
    var options = {
      zoom: 3,
      center: new google.maps.LatLng(45.50867, -73.553992),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
    };
    // END OF MAP STYLE
    // MAP LOADING 

    var that = this;
    that.mapr = new google.maps.Map(document.getElementById('map3'), {
      center: { lat: -34.397, lng: 150.644 },
      zoom: 8
    });
    that.mapr.setOptions({
      styles: that.style,
      minZoom: 2, maxZoom: 20
    });

    setTimeout(() => {

      var start = new google.maps.LatLng(this.route_map_lt[0], this.route_map_lt[1]);
      var end = new google.maps.LatLng(this.route_map_lng[0], this.route_map_lng[1]);

      var directionsDisplay = new google.maps.DirectionsRenderer();// also, constructor can get "DirectionsRendererOptions" object
      directionsDisplay.setMap(this.mapr); // map should be already initialized.

      var request = {
        origin: start,
        destination: end,
        travelMode: google.maps.TravelMode.DRIVING
      };
      var directionsService = new google.maps.DirectionsService();
      directionsService.route(request, function (response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response);
        }
      });
    }, 100);
  }
  changebid(bid) {
    this.cancellation_bid = bid;
  }
  cancelReason(bid) {
    if (bid == 0) {
      bid = this.cancellation_bid;
    }
    $(".booking_loader_parent").show();
    this.cancel_reasons = [];
    this.cancellation_bid = "";
    this._dispatcherHomeService.cancelreasons({
      "userType": "1",
      "lang": myGlobals.lang
    }).subscribe((res) => {
      $(".booking_loader_parent").hide();
      if (res.errFlag == 0) {
        res.data.bid = bid;
        this.cancel_reasons = res.data;
        $("#appcancel_rs").modal('show');
        $("#details_task").modal('hide');
        this.cancellation_bid = bid;
      }
      else {
        alert(res.errMsg);
      }
    });
  }

  // EXPORT TASKS IN CSV FORMAT
  exportToCsv(filename, rows) {
    var processRow = function (row) {
      var finalVal = '';
      for (var j = 0; j < row.length; j++) {
        var innerValue = row[j] === null ? '' : row[j].toString();
        if (row[j] instanceof Date) {
          innerValue = row[j].toLocaleString();
        };
        var result = innerValue.replace(/"/g, '""');
        if (result.search(/("|,|\n)/g) >= 0)
          result = '"' + result + '"';
        if (j > 0)
          finalVal += ',';
        finalVal += result;
      }
      return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
      csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  passDetails(i: number) {
    $("#job_details_button").trigger('click');
    var that = this;
    this.passDetailsContent = this.bookings[i];
    this.getCustomerBookings(this.passDetailsContent.bookingId);
  }

  bookingInvoice(id) {
    window.open(this.invoice_link + '/api/emailInvoices/' + id + '.pdf');
  }

  hideShow_job() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#job_details_button").addClass("active");
    $('.details_description').show();
  }
  hideShow_activity() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#activity_timeline_button").addClass("active");
    $('.details_description2').show();
  }
  hideShow_path() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#path_history_button").addClass("active");
    $('.details_description3').show();
    this.displayRoute();
  }
  hideShow_docs() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#documents_show").addClass("active");
    $('.details_description4').show();
  }
  hideShow_invoice() {
    $(".tabs_details").hide();
    $(".details_but_sytle").removeClass("active");
    $("#invoice_show").addClass("active");
    $('.details_description5').show();
  }
  // EXPORT CSV TASKS 3 FUNCTIONS ON CLICK IN EXPORTS POPUP 
  all_tasks() {
    $("#date_range_div").hide();
    this.request_all = "All";
    this.all_task = true;
    this.today_task = false;
    this.custom_select = false;
  }
  today_tasks() {
    this.request_all = "";
    $("#date_range_div").hide();
    this.today_task = true;
    this.all_task = false;
    this.custom_select = false;
  }
  custom_selection() {
    this.request_all = "";
    $("#date_range_div").show();
    this.all_task = false;
    this.today_task = false;
    this.custom_select = true;
  }

  convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0]);
    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });
    return result;
  }

  downloadCSV(args) {
    var data, filename, link;
    var csv = this.convertArrayOfObjectsToCSV({
      data: this.stockData
    });
    if (csv == null) return;
    filename = args.filename || 'export.csv';
    if (!csv.match(/^data:text\/csv/i)) {
      csv = 'data:text/csv;charset=utf-8,' + csv;
    }
    data = encodeURI(csv);

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
  }

  convertString(phrase) {
    var maxLength = 100;
    var returnString = phrase.toLowerCase();
    //Convert Characters
    returnString = returnString.replace(/ö/g, 'o');
    returnString = returnString.replace(/ç/g, 'c');
    returnString = returnString.replace(/ş/g, 's');
    returnString = returnString.replace(/ı/g, 'i');
    returnString = returnString.replace(/ğ/g, 'g');
    returnString = returnString.replace(/ü/g, 'u');
    // if there are other invalid chars, convert them into blank spaces
    returnString = returnString.replace(/[^a-z0-9\s-]/g, "");
    // convert multiple spaces and hyphens into one space       
    returnString = returnString.replace(/[\s-]+/g, " ");
    // trims current string
    returnString = returnString.replace(/^\s+|\s+$/g, "");
    // cuts string (if too long)
    if (returnString.length > maxLength)
      returnString = returnString.substring(0, maxLength);
    // add hyphens
    returnString = returnString.replace(/\s/g, "-");

    return returnString;
  }

  ngOnInit() {
    this.nextEnable = true;
    this.outoff = this.limit;
    this.myname = this._cookie.getItem('firstName');
    this.myphn = this._cookie.getItem('phone');
    this.mymail = this._cookie.getItem('email');
    this.range = 10;
    this.getAllBooking();

    // Toaseter
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": true,
      "positionClass": "toast-top-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "8000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    this.tasks = this.languageService.tasks;
    this.disphome = this.languageService.dispatcherhome;
    this.jobdetails = this.languageService.job_details;
    this.invoice = this.languageService.invoice;
    this.cancelbooking = this.languageService.cancel_booking;

    $(".booking_buutns").hide();
    this.fname_b = this._cookie.getProfile('firstName');
    this.fmail_b = this._cookie.getProfile('email');
    this.fphone_b = this._cookie.getProfile('phone');

    $('#bulk_export_button_tasks').click(() => {
      this.current_time = moment().format('YYYY-MM-DD');
      if (this.today_task == true) {
        this.export_start_date = this.current_time;
        this.export_end_date = "";
      }
      else if (this.custom_select = true) {
        this.export_start_date = $(".bulk_export_date").val();
        this.export_end_date = $(".bulk_export_date2").val();
      }
    });

    $("#load_next").click(() => {
      this.ent_page_index++;
    });
    $('#tasks_refresh').click(() => {
      this.data1 = [];
    });

    $("button.confirm").click(function () {
    });
    $('.filters_but').click(function () {
      $('#filters_but_body').toggle();
      $('.filters_but .glyphicon.glyphicon-triangle-bottom').toggleClass('active');
    })

    $("#hidden_flipping_assign").click(() => {
      var content = $("#hidden_flipping_assign").text();
      var splitted_content = content.split(',');
      var bid = splitted_content[0];
      var status = splitted_content[1];
      var msg = splitted_content[2];
      var date_bid = splitted_content[3];
      $("tr#" + bid).removeClass('color_changing');
      for (var inst = 0; inst < this.data1.length; inst++) {
        if (this.data1[inst].bid == bid) {
          this.data1[inst].shipemntDetails[0].status = status;
          this.data1[inst].status = msg;
          switch (status) {
            case "7":
              this.data1[inst].shipemntDetails[0].DriverArrivedTime = date_bid;
              break;
            case "8":
              this.data1[inst].shipemntDetails[0].DriverLoadedStartedTime = date_bid;
              break;
            case "9":
              this.data1[inst].shipemntDetails[0].DriverReachedDropLocationTime = date_bid;
              break;
            case "16":
              this.data1[inst].shipemntDetails[0].DriverDropedTime = date_bid;
              break;
          }
          break;
        }
      }
      setTimeout(function () { $("tr#" + bid).addClass('color_changing'); }, 500);
    });

    $("#hidden_flipping_expired").click(() => {
      var bid = $("#hidden_flipping_expired").text();
      $("tr#" + bid).removeClass('color_changing');
      this.current_time = moment().format('YYYY-MM-DD HH:mm:ss');
      this._dispatcherHomeService.getdata({
        bookingId: bid
      }).subscribe((res) => {
        this.data1 = jQuery.grep(this.data1, (value) => {
          return value.bid != this.ent_driver_bid;
        });
        this.data1.splice(0, 0, res.data.appointments[0]);
        this.cancel_status_link = 0;
      });
      setTimeout(function () { $("tr#" + bid).addClass('color_changing'); }, 500);
    });

    $("#hidden_flipping").click(() => {
      var content = $("#hidden_flipping").text();
      var splitted_content = content.split(',');
      var bid = splitted_content[0];
      $("tr#" + bid).removeClass('color_changing');
      var status = splitted_content[1];
      this._dispatcherHomeService.getdata({
        bookingId: bid
      }).subscribe((res) => {
        if (res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime != undefined) {
          if (res.data.appointments[0].bookingTimeStamp != "0") {
            res.data.appointments[0].booking_time = moment.unix(res.data.appointments[0].bookingTimeStamp).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime != "0") {
            res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverLoadedStartedTime).format("MMMM Do YYYY, h:mm:ss a");
          }
          if (res.data.appointments[0].shipemntDetails[0].DriverAcceptedTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverAcceptedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverAcceptedTime).format("MMMM Do YYYY, h:mm:ss a");


          if (res.data.appointments[0].shipemntDetails[0].DriverArrivedTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverArrivedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverArrivedTime).format("MMMM Do YYYY, h:mm:ss a");

          if (res.data.appointments[0].shipemntDetails[0].DriverCompletedTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverCompletedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverCompletedTime).format("MMMM Do YYYY, h:mm:ss a");

          if (res.data.appointments[0].shipemntDetails[0].DriverReachedDropLocationTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverReachedDropLocationTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverReachedDropLocationTime).format("MMMM Do YYYY, h:mm:ss a");

          if (res.data.appointments[0].shipemntDetails[0].DriverDropedTime != "0")
            res.data.appointments[0].shipemntDetails[0].DriverDropedTime = moment.unix(res.data.appointments[0].shipemntDetails[0].DriverDropedTime).format("MMMM Do YYYY, h:mm:ss a");
        }

        if (status == "6") {
          this.data1 = jQuery.grep(this.data1, (value) => {
            return value.bid != res.data.appointments[0].bid;
          });
          this.data1.splice(0, 0, res.data.appointments[0]);
        }
        else if (status == "10") {
          this.data1 = jQuery.grep(this.data1, (value) => {
            return value.bid != res.data.appointments[0].bid;
          });
          this.data1.splice(0, 0, res.data.appointments[0]);
        }
        setTimeout(function () { $("tr#" + bid).addClass('color_changing'); }, 500);
      });
    });

    $('#search_date_range').click(() => {
      this.fromDate = $(".flatpickr1").val();
      this.toDate = $(".flatpickr2").val();
      this.status = '';
      this.search = '';
      $('#searchKey').val('');
      if (this.fromDate == "" || this.toDate == "") {
        alert(this.cancelbooking.validDateRange);
      }
      else {
        this.current_time = moment().format('YYYY-MM-DD HH:mm:ss');
        $("#loader_bookings_parent").show();
        this.getAllBooking();
      }
    });

    jQuery('#back_button').show();
    flatpickr(".flatpickr1", {
      defaultDate: new Date(), // Date objects and date strings are also accepted
      enableTime: false,
      altFormat: "M j, Y"
    });
    flatpickr(".flatpickr2", {
      defaultDate: new Date(), // Date objects and date strings are also accepted
      enableTime: false,
      altFormat: "M j, Y"
    });
  }

  // START OF UBER FOR ALL API CALLS
  // booking history
  getCustomerBooking() {
    if (this.page_index == 0) {
      this.assigned_count = 0;
      this.completed_count = 0;
      this.assigned_full_count = 0;
    }
    $("#loader_bookings_parent").show();
    this._dispatcherHomeService.gethistory({
    }).subscribe((res) => {
      $("#loader_bookings_parent").hide();
      if (res.data.length == 0) {
        $(".more_tooltip_error").show();
        setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
      }
      else {
        var response_ins = 0;
        const bookingData = res.data;
        for (let asgn = 0; asgn < bookingData.assigned.length; asgn++) {
          if (bookingData.assigned.status == 6, 7, 8, 9, 10, 11) {
            this.assigned.push(bookingData.assigned[asgn]);
            this.assigned_count = this.assigned.length;
          }
        }

        for (let unasgn = 0; unasgn < bookingData.unassigned.length; unasgn++) {
          if (bookingData.unassigned[unasgn].status == 2) {
            this.unassigned.push(bookingData.unassigned[unasgn]);
            this.assigned_full_count = this.unassigned.length;
          }
        }

        for (let past = 0; past < bookingData.past.length; past++) {
          if (bookingData.past[past].status == 3, 4, 5, 12, 13) {
            this.past.push(bookingData.past[past]);
            this.completed_count = this.past.length;
          }
        }
        let two = this.assigned.concat(this.unassigned);
        this.data1 = two.concat(this.past);
      }
    }
      , (err) => {
        console.log('errMsg', err.status);
        if (err.status > 401 && err.status < 500) {
          err.status = 420; // merging all the status codes to one status code 420
        }
        if (err.status > 499) {
          err.status = 520; // merging all the status codes to one status code 420
        }
        switch (err.status) {
          case 0:
            $("#loader_bookings_parent").hide();
            toastr["error"]("Bad Request!");
            break;
          case 520:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 400:
            $("#loader_bookings_parent").hide();
            this.errMsg = JSON.parse(err._body);
            toastr["error"](this.errMsg.message);
            break;
          case 401:
            this._cookie.removeItem();
            this._router.navigate(['login']);
            break;
          case 420:
            $("#loader_bookings_parent").hide();
            this.errmessage = JSON.parse(err._body);
            this.errmessage = this.errmessage.message;
            break;
        }
      })
  }

  vehicleDetails = false;
  // SHOW DETAILS POPUP
  show_details(i) {
    event.stopPropagation();
      if(this.bookings[i].status == 12) {
        this.vehicleDetails = true;
      } else {
        this.vehicleDetails = false;
      }
      // this.passDetailsContent1 = this.bookings[i];
    setTimeout(() => {
      $("#card").toggleClass("flipped");
      $("#details_task_tabs li").removeClass('active');
      $(".tab-pane").removeClass('active in');
      $("#details_task_tabs li:first-child").addClass('active');
      $("#home").addClass("active");
      $("#home").addClass("in");
      jQuery(".container_flip_parent").addClass('show_div');
    }, 100);
  }

  // END OF UBER FOR ALL API CALLS
}


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/dispatcher/tasks/tasks.component.ts